// Généré par maquettes/outils/dc2react.py à partir de la maquette. Ne pas modifier à la main :
// changer maquettes/src puis relancer le script.
import React from 'react';

export default function APropos({ v }) {
  return (
    <section className="m-sec" id="apropos" style={{ maxWidth: "1240px", margin: "0 auto", padding: "96px 24px", display: "flex", flexDirection: "column", gap: "36px" }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(440px, 100%), 1fr))", gap: "20px 64px", alignItems: "end" }}>
        <h2 style={{ margin: "0", fontSize: "clamp(32px, 3.4vw, 48px)", fontWeight: "800", fontStretch: "80%", lineHeight: "1.04", textWrap: "balance" }}>
          Je ne découvre pas l'e‑commerce en arrivant chez vous.
        </h2>
        <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.55", color: "#30353C" }}>
          Mattéo, ingénieur data. Dans l'e‑commerce, je remplace les Excel des équipes ventes, achats, logistique et direction par une base unique, et je construis dessus les outils qu'elles ouvrent chaque matin : réappro multicanal, marge par canal, suivi des réceptions et des retours.
        </p>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(220px, 100%), 1fr))", gap: "1px", background: "#E3E5E8", border: "1px solid #E3E5E8" }}>
        <div style={{ padding: "18px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "4px" }}>
          <p style={{ margin: "0", fontWeight: "700" }}>
            Je connais votre métier
          </p>
          <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
            Couverture de stock, MOQ, marge par canal : on gagne des semaines de cadrage.
          </p>
        </div>
        <div style={{ padding: "18px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "4px" }}>
          <p style={{ margin: "0", fontWeight: "700" }}>
            Un seul interlocuteur
          </p>
          <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
            Du besoin au code, sans commercial ni sous-traitant. Deux projets à la fois au maximum, réponse sous 24 h ouvrées.
          </p>
        </div>
        <div style={{ padding: "18px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "4px" }}>
          <p style={{ margin: "0", fontWeight: "700" }}>
            Vos données dans votre IA
          </p>
          <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
            Je les rends interrogeables depuis Claude ou ChatGPT, avec les mêmes droits que vos écrans.
          </p>
        </div>
      </div>
    </section>
  );
}
